export function getStatusConfig(statusSlug) {
  const statusMap = {
    "pct-identificado": { color: "#dbeafe", icon: "mdi-account-search" },
    "potencial-doador": { color: "#e0f2fe", icon: "mdi-account-heart" },
    "aguardando-encerramento-pme": {
      color: "#fef9c3",
      icon: "mdi-clock-outline",
    },
    "doacao-aut": { color: "#dcfce7", icon: "mdi-check-circle-outline" },
    "doacao-nao-aut": { color: "#fee2e2", icon: "mdi-close-circle-outline" },
    "pme-concluido": { color: "#d9e8d5", icon: "mdi-check-circle" },
    "pme-nao-concluido": { color: "#fde68a", icon: "mdi-alert-outline" },
    doador: { color: "#bbf7d0", icon: "mdi-heart" },
    "concluido-sem-transp": { color: "#a7f3d0", icon: "mdi-heart-multiple" },
    "potencial-corneas": { color: "#cffafe", icon: "mdi-eye-outline" },
    "orgao-captado": { color: "#d1fae5", icon: "mdi-medical-bag" },
    "cornea-preservada": { color: "#ccfbf1", icon: "mdi-eye-check-outline" },
    "cornea-descartada": { color: "#fee2e2", icon: "mdi-eye-remove-outline" },
    "cornea-transplantada": { color: "#a5f3fc", icon: "mdi-eye-plus-outline" },
    "pct-nao-identificado": { color: "#f1f5f9", icon: "mdi-account-question" },
    "pct-inapto": { color: "#fecaca", icon: "mdi-alert-circle" },
    "pct-aval-neuro": { color: "#e0f2fe", icon: "mdi-brain" },
    "doacao-nao-efetivada": {
      color: "#fde68a",
      icon: "mdi-close-octagon-outline",
    },
    "doacao-iniciada": { color: "#ddd6fe", icon: "mdi-progress-clock" },
    "aguard-aval-med": { color: "#fef3c7", icon: "mdi-stethoscope" },
    "doacao-efetivada": { color: "#bbf7d0", icon: "mdi-check" },
    "transp-efetivado": { color: "#a7f3d0", icon: "mdi-ribbon" },
    "aguard-aut-familiar": { color: "#f7e4f7", icon: "mdi-account-multiple" },
    "finalizado-sem-entrevista-familiar": { color: "#fecaca", icon: "mdi-microphone-off"},
  };
  return (
    statusMap[statusSlug] || {
      color: "#e5e7eb",
      icon: "mdi-help-circle-outline",
    }
  );
}

export const donorStatus = {
  PACIENTE_IDENTIFICADO: {
    slug: "pct-identificado",
    label: "Paciente Identificado",
  },

  POTENCIAL_DOADOR: {
    slug: "potencial-doador",
    label: "Potencial Doador",
  },

  AGUARD_ENCER_PME: {
    slug: "aguardando-encerramento-pme",
    label: "Aguardando Encerramento PME",
  },

  PME_NAO_CONCLUIDO: {
    slug: "pme-nao-concluido",
    label: "PME não concluído",
  },

  PME_CONCLUIDO: {
    slug: "pme-concluido",
    label: "PME Concluído",
  },

  DOACAO_AUTORIZADA: {
    slug: "doacao-aut",
    label: "Doação Autorizada",
  },

  DOACAO_NAO_AUTORIZADA: {
    slug: "doacao-nao-aut",
    label: "Doação Não Autorizada",
  },

  FINALIZADO_SEM_DOACAO: {
    slug: "finalizado-sem-doacao",
    label: "Finalizado sem Doação",
  },

  DOADOR: {
    slug: "doador",
    label: "Doador",
  },

  CONCLUIDO_SEM_TRANSPLANTE: {
    slug: "concluido-sem-transp",
    label: "Concluído sem Transplante",
  },

  POTENCIAL_DOADOR_CORN: {
    slug: "potencial-corneas",
    label: "Potencial Doador de Córneas",
  },

  ORGAO_CAPTADO: {
    slug: "orgao-captado",
    label: "Órgão Captado",
  },

  DOADOR_CORNEA_PRESERVADAS: {
    slug: "cornea-preservada",
    label: "Doador com Córneas Preservadas",
  },

  DOADOR_CORNEA_DESCARTADAS: {
    slug: "doador-descartada",
    label: "Doador com Córneas Descartadas",
  },

  DOADOR_CORNEA_TRANSPLANTADA: {
    slug: "cornea-transplantada",
    label: "Doador com Córneas Transplantadas",
  },

  PACIENTE_NAO_IDENTIFICADO: {
    slug: "pct-nao-identificado",
    label: "Paciente não identificado",
  },

  PACIENTE_INAPTO: {
    slug: "pct-inapto",
    label: "Paciente Inapto",
  },

  PACIENTE_EM_AVALI_NEUROLOGICA: {
    slug: "pct-aval-neuro",
    label: "Paciente em Avaliação Neurológica",
  },

  DOACAO_NAO_EFETIVADA: {
    slug: "doacao-nao-efetivada",
    label: "Doação Não Efetivada",
  },

  DOACAO_INICIADA: {
    slug: "doacao-iniciada",
    label: "Doação Iniciada",
  },

  AGUARDANDO_AVAL_MEDICA: {
    slug: "aguard-aval-med",
    label: "Aguardando Avaliação Médica",
  },

  DOACAO_EFETIVADA: {
    slug: "doacao-efetivada",
    label: "Doação Efetivada",
  },

  TRANSPANTE_EFETIVADO: {
    slug: "transp-efetivado",
    label: "Transplante Efetivado",
  },

  AGUARDANDO_AUT_FAMILIAR: {
    slug: "aguard-aut-familiar",
    label: "Aguardando Autorização Familiar",
  },

  FINALIZADO_SEM_ENTREVISTA: {
    slug: "finalizado-sem-entrevista-familiar",
    label: "Finalizado sem entrevista familiar",
  },
};
